export default __webpack_public_path__ + "static/Avenir-Heavy-05-47f40c176f4432e132cfa1899bbc2f0f.woff";